import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { toggleShowMyVideoSettings as toggleShowMyVideoSettingsAction } from '../../../../settings';
import { getShowMyVideo } from '../../../../settings/selectors';
import { SettingsTumbler } from './settings-tumbler';

export const ShowMeTumbler: FunctionComponent = () => {
    const { toggleShowMyVideoSettings } = useActions({ toggleShowMyVideoSettings: toggleShowMyVideoSettingsAction });

    const showMyVideo = useSelector(getShowMyVideo);

    const onChange = () => toggleShowMyVideoSettings();

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'video-show-me')}
            checked={showMyVideo}
            onChange={onChange}
            testId="show-me-tumbler"
        />
    );
};
